import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Typography } from '@comparethemarketau/manor-typography';

const ProductUnderwritten = (props) => {
    const { productUnderwriterName, className } = props;
    return (
        <Typography className={className}>
            {`Underwritten by ${productUnderwriterName}.`}
        </Typography>
    );
};

ProductUnderwritten.propTypes = {
    className: PropTypes.string,
    productUnderwriterName: PropTypes.string
};

export { ProductUnderwritten };
